import { NavLink } from "react-router-dom";
import { HardHat } from "lucide-react";
import { APP_NAME } from "@crewledger/shared/constants";
import { NAV_ITEMS } from "@/lib/navigation";
import { cn } from "@/lib/utils";

export function AppSidebar() {
  return (
    <aside className="hidden w-60 shrink-0 flex-col bg-navy-deep text-sidebar-foreground md:flex lg:w-64">
      <div className="flex h-16 items-center gap-2.5 border-b border-white/10 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-construction">
          <HardHat className="h-4 w-4 text-navy-deep" />
        </div>
        <div>
          <span className="block text-sm font-bold tracking-tight text-white">{APP_NAME}</span>
          <span className="block text-[10px] uppercase tracking-widest text-white/50">
            Command Center
          </span>
        </div>
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto p-3">
        {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                isActive
                  ? "bg-navy-blueprint text-white shadow-sm ring-1 ring-orange-construction/40"
                  : "text-white/70 hover:bg-navy-blueprint/60 hover:text-white",
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  className={cn(
                    "h-4 w-4 shrink-0",
                    isActive ? "text-orange-construction" : "text-white/50",
                  )}
                />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-white/10 p-4">
        <p className="text-[10px] uppercase tracking-widest text-white/40">Labor · Equipment · Pay</p>
      </div>
    </aside>
  );
}
